import { PropsWithChildren, useMemo } from 'react';

import {
  OrderProvider as BaseOrderProvider,
  OrderProviderProps as BaseOrderProviderProps,
} from 'modules/order/common/providers/OrderProvider';

import { OrderContext, OrderContextProps } from './orderContext';

export interface OrderProviderProps extends OrderContextProps {
  isIsinFreeSolo?: boolean;
}

export const OrderProvider = ({
  children,
  order,
  onChangeStatus,
  onDelete,
  onEnableEdit,
  onDisableEdit,
  onDownloadOrder,
  ...baseProps
}: OrderContextProps & BaseOrderProviderProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({
      order,
      onChangeStatus,
      onDelete,
      onEnableEdit,
      onDisableEdit,
      onDownloadOrder,
    }),
    [
      order,
      onChangeStatus,
      onDelete,
      onEnableEdit,
      onDisableEdit,
      onDownloadOrder,
    ]
  );

  return (
    <OrderContext.Provider value={value}>
      <BaseOrderProvider {...baseProps}>{children}</BaseOrderProvider>
    </OrderContext.Provider>
  );
};
